// libs
import React, { memo, useState, useEffect } from 'react';

// components
import Image from 'shared/layouts/DetailsPage/components/ProductImage/components/Image';
import ImageSelector from 'shared/layouts/DetailsPage/components/ProductImage/components/ImageSelector';

// hooks
import { useSelectedSKUMedias } from 'shared/store/details/hooks/selectors';

// helpers
import { clearImagesViewed } from 'shared/layouts/DetailsPage/components/ProductImage/helpers';

function ProductImageDesktop() {
  const [selectedImage, setSelectedImage] = useState(0);
  const images = useSelectedSKUMedias();

  // on size change images might also change so resetting index to 0
  useEffect(() => {
    setSelectedImage(0);
  }, [images]);

  useEffect(() => {
    clearImagesViewed();
  }, []);

  return (
    <>
      <ImageSelector selectedImage={selectedImage} setSelectedImage={setSelectedImage} />
      <Image selectedImage={selectedImage} />
    </>
  );
}

export default memo(ProductImageDesktop);
